import { render } from "./articleCollect.vue?vue&type=template&id=3feea2a5&scoped=true"
import script from "./articleCollect.vue?vue&type=script&lang=js"
export * from "./articleCollect.vue?vue&type=script&lang=js"

import "./articleCollect.vue?vue&type=style&index=0&id=3feea2a5&lang=scss&scoped=true"
import "./articleCollect.vue?vue&type=style&index=1&id=3feea2a5&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3feea2a5"]])

export default __exports__